import UrlUtils from '../common/util/url.es6';

export default class ApiClient {
    constructor(apiUrl) {
        this.query = UrlUtils.getQuery() || {};
        /*
        if(this.query.dev==='1'){
            const path = document.body.classList.contains('top') ? './' : '../';
            this.apiUrl = `${path}assets/json/news.json?v=${new Date().getTime()}`;
        }
        else{
            this.apiUrl = apiUrl;
        }
        */
        this.apiUrl = apiUrl;
    }

    async fetchData() {
        try {
            const response = await fetch(this.apiUrl);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            throw error;
        }
    }
}
